import { Button, Col, notification, Result, Row } from 'antd';
import type { OAuthProvider } from 'osep-auth-service-client-v1';
import React from 'react';
import { useStartOAuthFlowMutation } from '../../hooks/mutations/useStartOAuthFlowMutation';
import { PROVIDERS } from './providers';

type Props = {
  provider: OAuthProvider;
  reason: string;
  logoWidth?: number;
  minHeight?: string;
};

const ConnectPrompt: React.FC<Props> = ({
  provider,
  reason,
  logoWidth = 100,
  minHeight = '40vh',
}) => {
  const [api, notificationHolder] = notification.useNotification();
  const { label, logo } = PROVIDERS[provider];
  const { mutate: startOAuthFlow, isPending } = useStartOAuthFlowMutation();

  return (
    <>
      {notificationHolder}
      <Row justify="center" align="middle" style={{ minHeight }}>
        <Col>
          <Result
            status="error"
            icon={<img src={logo} style={{ width: logoWidth }} alt="" />}
            title={`You're not connected to ${label}`}
            subTitle={reason}
            extra={[
              <Button
                key="connect"
                type="primary"
                loading={isPending}
                onClick={() =>
                  startOAuthFlow(provider, {
                    onError: () =>
                      api.error({
                        message: 'Connection failed',
                        description: `Could not start the ${label} connection. Please try again.`,
                      }),
                  })
                }
              >
                Connect to {label}
              </Button>,
            ]}
          />
        </Col>
      </Row>
    </>
  );
};

export default ConnectPrompt;
